import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const AlertIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 16 17" fill="transparent" stroke="#C6212B" {...props}>
    <path
      d="M8.00093 6.49983V7.83317M8.00093 10.4998H8.00759M3.38226 13.1665H12.6196C13.6463 13.1665 14.2876 12.0552 13.7743 11.1665L9.15559 3.1665C8.64226 2.27783 7.35959 2.27783 6.84626 3.1665L2.22759 11.1665C1.71426 12.0552 2.35559 13.1665 3.38226 13.1665Z"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </SvgIcon>
);
